import { render, staticRenderFns } from "./LpuMedals.vue?vue&type=template&id=43db9773&scoped=true&"
import script from "./LpuMedals.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuMedals.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuMedals.vue?vue&type=style&index=0&id=43db9773&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43db9773",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43db9773')) {
      api.createRecord('43db9773', component.options)
    } else {
      api.reload('43db9773', component.options)
    }
    module.hot.accept("./LpuMedals.vue?vue&type=template&id=43db9773&scoped=true&", function () {
      api.rerender('43db9773', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuMedals/LpuMedals.vue"
export default component.exports